<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('blacklist reports')"
      :columns="columns"
      :column_search="true"
      resource_url="/blacklist-report/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <blacklist-modal ref="blacklist_modal" @success="refresh" />
  <log-modal ref="log_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  download,
  post,
  success_message,
  error_message,
  format_currency,
} from "@/utils";
import BlacklistModal from "./blacklist_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";
import moment from "moment";

export default {
  name: "BlacklistDatatable",
  components: { GenericTable, BlacklistModal, LogModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">${row.name || ""}</div>
            <div class="subtitle mb-0 is-6">${row.dpi || ""}</div>
            <div class="subtitle is-6">${
              row.promissory_note_number || ""
            }</div>`;
          },
        },
        // {
        //   title: v.$t("dpi"),
        //   searchable: false,
        //   data: (row) => {
        //     return row.dpi || "";
        //   },
        // },
        // {
        //   title: v.$t("promissory note number"),
        //   searchable: false,
        //   data: (row) => {
        //     return row.promissory_note_number || "";
        //   },
        // },
        {
          title: v.$t("blacklist status"),
          searchable: false,
          data: (row) => {
            if (row.is_blacklisted)
              return `<span class="icon has-text-danger"><i class="fa fa-times"></i></span><span class="is-7">${v.$t(
                "is blacklisted"
              )}</span>`;
            else
              return `<span class="icon has-text-success"><i class="fa fa-check"></i></span><span class="is-7">${v.$t(
                "is not blacklisted"
              )}</span>`;
          },
        },
        {
          title: v.$t("reason"),
          searchable: false,
          data: (row) => {
            if (row.status == "success") {
              if (row.is_blacklisted) {
                let descriptions = row.blacklist_matches.map((match) => {
                  return `<div class"title is-7">${match.columna4}</div>
                  <div class="subtitle mb-0 is-7">${match.columna3}</div>
                  <div class="subtitle mb-0 is-7">${match.columna2}</div>
                  <div class="subtitle is-7">${match.columna1}</div>`;
                });
                return descriptions.join("");
              } else {
                return "";
              }
            } else {
              return `<pre>${row.error}</pre>`;
            }
          },
        },
        {
          title: v.$t("report generation result"),
          searchable: false,
          data: (row) => {
            if (row.report_result) {
              if (row.report_result.result == "ok")
                return `<span class="icon has-text-success"><i class="fa fa-check"></i></span><span>${v.$t(
                  "report generated"
                )}</span>`;
              else
                return `<span class="icon has-text-danger"><i class="fa fa-times"></i></span><span>${v.$t(
                  "error generating report"
                )}</span>`;
            } else return "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: false,
        //   width: "80%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("edit"),
              //   icon: "fa fa-edit",
              //   icon_class: "is-small",
              //   click: function (e) {
              //     // console.log("edit order", e.detail.uuid);
              //     v.$refs.blacklist_modal.edit_modal(e.detail.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete blacklist report?"),
                    v,
                    () => {
                      del("/blacklist-report", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("start"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  post("/blacklist-report/start", { uuid: uuid })
                    .then(() => {
                      console.log("report generated");
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$refs.log_modal.show_modal(uuid);
                },
              },
            ];

            if (row.report_result && row.report_result.file_location) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("download report"),
                icon: "fa fa-download",
                icon_class: "is-small",
                click: function (e) {
                  download(
                    `/blacklist-report/download?uuid=${e.detail.uuid}`,
                    `Lista Negra ${row.name} ${moment().format(
                      "YYYYMMDDHHmmss"
                    )}.pdf`
                  )
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.blacklist_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
